import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=130b04e0&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
import style0 from "./UserRegister.vue?vue&type=style&index=0&id=130b04e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b04e0",
  null
  
)

export default component.exports